import React from 'react';
import { useSelector } from 'react-redux';
import { Icons } from './base/BootstrapComponents';
import { getClientPersonalData } from '../modules/Client/reducer';

export default function CheckBoxInputWithLabel(props) {
  const {
    name,
    position,
    avatar_fullpath,
    updated_at,
  } = useSelector(getClientPersonalData);
  const defaultAvatar = `${process.env.PUBLIC_URL}/default-avatar.svg`;
  const avatar = avatar_fullpath && avatar_fullpath.thumb ? avatar_fullpath.thumb : defaultAvatar;
  const avatarLink = `${avatar}?v=${updated_at}`;
  return (
    <div className="mini-profile-anchor">
      <div className="mini-profile-wrapper">
        {/* <Icons customIcon icon="notifications" className="mini-profile-notifications" /> */}
        <div className="mini-profile-separator" />
        <div className="mini-profile-data">
          <div className="profile-data-name">{name}</div>
          <div className="profile-data-position f8">{position || 'Пользователь'}</div>
        </div>
        <div className="mini-profile-image">
          <img src={avatarLink} alt="A" onError={a => { a.target.src = defaultAvatar; }} />
        </div>
      </div>
    </div>
  );
}
